import { memo } from 'react'

import { ListItemProps } from './list-item.model'
import * as S from './styles'

interface OrderedListProps {
  items: ListItemProps[],
  type?: '1' | 'A' | 'a' | 'I' | 'i'
  $pl?: 'sm' | 'md'
  $prefix?: string
}

export const OrderedList = memo(({ items, type='1', $pl='sm', $prefix } : OrderedListProps) => (
  <S.OrderedList type={type} $pl={$pl} $prefix={$prefix}>
    {items.map(({ id, content }) => (
      <S.ListItem key={id}>{content}</S.ListItem>
    ))}
  </S.OrderedList>
))

OrderedList.displayName = 'OrderedList'
